module.exports = __webpack_public_path__ + "static/img/screen-control-close.0dc6bd64.svg";